export default __webpack_public_path__ + "6cfaa1feed74092383c14dde7b368f3d.svg";